import { CAMPAIGN_INSTRUCTION_TYPE } from 'modules/campaigns/config';

export const hasNoItems = campaignItemType =>
    campaignItemType === CAMPAIGN_INSTRUCTION_TYPE.HAS_NO_ITEMS ||
    campaignItemType === CAMPAIGN_INSTRUCTION_TYPE.HAS_NO_ITEMS_DISPLAY;
